export var ESortPostsBy;
(function (ESortPostsBy) {
    ESortPostsBy["CREATED"] = "CREATED";
    ESortPostsBy["VOTES"] = "VOTES";
    ESortPostsBy["CLAPS"] = "CLAPS";
    ESortPostsBy["REACTS"] = "REACTS";
})(ESortPostsBy || (ESortPostsBy = {}));
